"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
var person_config_1 = require("./person.config");
var lodash_1 = require("lodash");
// customise language strings for profile instead
var fields = (0, lodash_1.cloneDeep)(person_config_1.Person.form.fields);
fields.name.description = 'What is your full name?';
fields.locations.description = 'Where are you primarily located?';
fields.states.description = 'Alternatively, are you located in any geographic {{State.plural}}?';
fields.economies.description = 'Alternatively, are you located in any specific or any other {{Economy.plural}}?';
fields.phone.description = 'What is your primary phone number?';
fields.platformObjective.description = 'Please describe the reasons why you are part of the platform and what you can offer to the network';
fields.email.description = 'What is your current email address?';
fields.websiteUrl.description = 'Do you have a personal website you publish to?';
fields.twitter.description = 'What is the Public URL of your Twitter profile?';
fields.facebook.description = 'What is the Public URL of your Facebook profile?';
fields.challengeExpertise.description = 'Identify your levels of {{CHALLENGE}} expertise and interest by adding them here.';
fields.keyIssueExpertise.description = 'Identify your levels of {{KEY_ISSUE}} expertise and interest by adding them here.';
fields.trendExpertise.description = 'Identify your levels of {{TREND}} expertise and interest by adding them here.';
fields.topicExpertise.description = 'Identify your levels of {{TOPIC}} expertise and interest by adding them here.';
fields.subTopicExpertise.description = 'Identify your levels of {{SUB_TOPIC}} expertise and interest by adding them here.';
fields.sdgExpertise.description = 'Identify your levels of {{SDG}} expertise and interest by adding them here.';
fields.courseRegistrations.description = 'Which {{COURSES}} are you registered for?';
fields.agreesToSharePersonalInfo.description = 'Do you agree to share your personal contact info (email, phone number) with other active {{USERS}} of the platform?';
fields.bio.description = 'Please provide a brief bio about your career and achievements.';
fields.hideEmail.description = "Hide my email address from other members";
fields.hideEmail.isVisible = function () {
  return true;
};
fields.hidePhone.description = "Hide my phone number from other members";
fields.hidePhone.isVisible = function () {
  return true;
};
(0, lodash_1.set)(fields, 'followingChallenges.description', 'Which {{CHALLENGES}} are you following?');
(0, lodash_1.set)(fields, 'followingChapters.description', 'Which {{CHALLENGES}} are you following?');
(0, lodash_1.set)(fields, 'followingCourses.description', 'Which {{COURES}} are you following?');
(0, lodash_1.set)(fields, 'followingEconomies.description', 'Which {{ECONOMIES}} are you following?');
(0, lodash_1.set)(fields, 'followingEvents.description', 'Which {{EVENTS}} are you following?');
(0, lodash_1.set)(fields, 'followingFeedEntries.description', 'Which {{FEED_ENTRIES}} are you following?');
(0, lodash_1.set)(fields, 'followingImpactStories.description', 'Which {{IMPACT_STORIES}} are you following?');
(0, lodash_1.set)(fields, 'followingKeyIssues.description', 'Which {{KEY_ISSUES}} are you following?');
(0, lodash_1.set)(fields, 'followingLessons.description', 'Which {{LESSONS}} are you following?');
(0, lodash_1.set)(fields, 'followingLocations.description', 'Which {{LOCATIONS}} are you following?');
(0, lodash_1.set)(fields, 'followingOrganisations.description', 'Which {{ORGANISATIONS}} are you following?');
(0, lodash_1.set)(fields, 'followingPages.description', 'Which {{PAGES}} are you following?');
(0, lodash_1.set)(fields, 'followingPeople.description', 'Which {{PEOPLE}} are you following?');
(0, lodash_1.set)(fields, 'followingProducts.description', 'Which {{PRODUCTS}} are you following?');
// set(fields, 'followingSessions.description', 'Which {{SESSIONS}} are you following?');
(0, lodash_1.set)(fields, 'followingTeams.description', 'Which {{TEAMS}} are you following?');
(0, lodash_1.set)(fields, 'followingTopics.description', 'Which {{TOPICS}} are you following?');
(0, lodash_1.set)(fields, 'followingWorkstreams.description', 'Which {{WORKSTREAMS}} are you following?');
(0, lodash_1.set)(fields, 'followingChallenges.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingChapters.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingCourses.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingEconomies.fieldSet', 'following');
// set(fields, 'followingEvents.fieldSet', 'following');
// set(fields, 'followingFeedEntries.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingImpactStories.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingKeyIssues.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingLessons.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingLocations.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingOrganisations.fieldSet', 'following');
// set(fields, 'followingPages.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingPeople.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingProducts.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingSessions.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingTeams.fieldSet', 'following');
(0, lodash_1.set)(fields, 'followingTopics.fieldSet', 'following');
// set(fields, 'followingWorkstreams.fieldSet', 'following');
fields.pinnedItems.fieldSet = 'overview';
fields.pinnedItems.description = 'Setup items to pin to your home screen for quick reference.';
exports.Profile = __assign(__assign({}, person_config_1.Person), {
  appSectionName: 'profile',
  aliasOf: 'Person',
  name: 'Profile',
  label: 'Profile',
  slug: 'profile',
  pluralSlug: 'profiles',
  pluralLabel: 'Profiles',
  typeName: 'Person',
  pluralTypeName: 'People',
  singleTypeName: 'person',
  updateTypeName: 'person',
  form: __assign(__assign({}, person_config_1.Person.form || {}), {
    name: 'profile-form',
    fields: fields
  })
});